import { Host, h } from "@stencil/core";
/** Represents a single tab and must be used inside a dnn-tabs element. */
export class DnnTab {
    constructor() {
        this.visible = false;
    }
    /** Shows the tab. */
    async show() {
        this.visible = true;
    }
    /** Hides the modal */
    async hide() {
        this.visible = false;
    }
    render() {
        return (h(Host, { key: '11e00bf6b0dc398bb1694334de73b98725261e9d' }, this.visible &&
            h("slot", { key: '222991618962f83b0ce79deee011979c3bfec2b5' })));
    }
    static get is() { return "dnn-tab"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dnn-tab.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dnn-tab.css"]
        };
    }
    static get properties() {
        return {
            "tabTitle": {
                "type": "string",
                "attribute": "tab-title",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Defines the tab title."
                },
                "getter": false,
                "setter": false,
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "visible": {}
        };
    }
    static get methods() {
        return {
            "show": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "Shows the tab.",
                    "tags": []
                }
            },
            "hide": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "Hides the modal",
                    "tags": []
                }
            }
        };
    }
}
//# sourceMappingURL=dnn-tab.js.map
